import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Box from "../../../../../../ui/Box";
import Breadcrumbs from "./../../../../../../ui/Breadcrumbs";
import Tabs from "../../../../../../ui/Tabs";
import { makeStyles } from "@material-ui/core/styles";
import TopBar from "./components/TopBar";
import Progress from "../../../../../../ui/Progress";
import { useMediaQuery } from 'react-responsive';
import ModuleInfoDrawer from "../../components/ModuleInfoDrawer";
import ModuleMainInfo from "./components/ModuleMainInfo";
import Purpose from "./components/Purpose";
import { getFullModule, getModulePurpose } from "../../store/actions";

const useStyles = makeStyles(() => ({
  mainRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
}));

const items = [
  { label: "Управление ООП", link: "#" },
  { label: "Ресурсы", link: "/work/app/manage/resources" },
  { label: "Образовательные программы и модули", link: "/work/app/manage/resources/programs" },
  { label: "Мои модули", link: "/work/app/manage/resources/programs/my-modules" }
];

const tabitems = [
  {number:0, caption: "Основные сведения"},
  {number:1, caption: "Цели реализации модуля"},
  /*{number:3, caption: "Требования к результатам обучения"},
  {number:4, caption: "Структура и содержание"},
  {number:5, caption: "Материально-технические условия реализации программы"},
  {number:6, caption: "Учебно-методическое обеспечение программы"},
  {number:7, caption: "Оценка качества освоения программы"},*/
  {number:2, caption: "Составители"}
];

const ModuleView = ({
  getFullModule,
  moduleFullInfo,
  getModulePurpose,
  modulePurpose,
  match,
  history
}) => {
  const { id } = match.params;
  const classes = useStyles();

  const returnBack = () => history.push("/work/app/manage/resources/programs");
  const isLarge = useMediaQuery({ minWidth: 1024 });
  const isSmall = useMediaQuery({ maxWidth: 774 });

  useEffect(() => {
    getFullModule(id);
    getModulePurpose(id);
  }, [id]);

  return(
    <div>
      <Breadcrumbs items={items} />
      {moduleFullInfo ? (
        <div className={classes.mainRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={() => getFullModule(id)}
                returnBack={returnBack}
                programFile={moduleFullInfo.programFile}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                <ModuleMainInfo disabled={true} moduleInfo={moduleFullInfo}/>
              </Box>
              <Box noMargin>
                <Purpose modulePurpose={modulePurpose}/>
              </Box>
            </Tabs>
          </div>
          {isLarge &&
          <ModuleInfoDrawer moduleId={id} open hideLink />}
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  moduleFullInfo: state.programs.moduleFullInfo,
  modulePurpose: state.programs.purpose
});

const mapDispatchToProps = dispatch => ({
  getFullModule: id => dispatch(getFullModule(id)),
  getModulePurpose: id => dispatch(getModulePurpose(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModuleView));
